<template>
  <div :class="{'is--pink': timeIsOver}">{{ time }}</div>
</template>

<script>
import * as moment from 'moment';

export default {
  props: ['ticketTime', 'criticalTime'],
  data() {
    return {
      time: '00:00',
      timeIsOver: false
    }
  },
  mounted() {
    this.$eventEmitter.subscribe(this.$eventEmitter.eventTypes.TIME_TICK, (time) => {
      let format = 'mm:ss';
      const pureTime = moment().subtract(moment.unix(this.ticketTime).diff(time.startOf('day'), 'seconds'), 'seconds');

      if (this.$timeService.convertToHours(pureTime) >= 1) format = 'HH:mm:ss';
      if (!this.timeIsOver && this.$timeService.convertToMinutes(pureTime) >= this.criticalTime) this.timeIsOver = true;

      this.time = pureTime.format(format);
    })
  }
}
</script>
